export type CookiesState = {
    [nonce: string]: {
        redirectTo: string;
        timestamp: number;
    };
};

export const COOKIES_STATE_KEY = 'state';

export { getCookie } from './getCookie';
export { setCookie } from './setCookie';
export { getState } from './getState';
export { getLatestStateData } from './getLatestStateData';
export { getStateByNonce } from './getStateByNonce';
export { setStateInCookies } from './setStateInCookies';
